import { SimpleLabelFragment } from '@app/pages/settings/graphql/labels.queries';
import gql from 'graphql-tag';

export const PageInfoFragment = gql`
	fragment PageInfoFragment on PageInfo {
		endCursor
		hasNextPage
		hasPreviousPage
		startCursor
	}
`;
export const fileSessionInfoFragment = gql`
	fragment FileEntityImportFragment on FileEntitiesImportType {
		pk
		name
		created
		status
	}
`;
export const CommentFragment = gql`
	fragment CommentFragment on CommentType {
		id
		objectId
		text
		author {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
			displayName
			imageUrl
		}
		created
		updated
		userKeycloackId
	}
`;
export const FileImportFragment = gql`
	fragment FileImportFragment on FileEntityType {
		fileEntityId
		version
		notes
		assets {
			name
			id
			pk
			location {
				name
				type
			}
		}
		createdBy {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
		}
		name
		pk
		created
		updated
		file {
			contentType
			isProcessed
			name
			url
		}
		workOrders {
			workOrderId
			name
			status
			priority
			pk
		}
		incidents {
			incidentId
			priority
			id
			pk
			name
			status
		}
		requests {
			requestId
			priority
			id
			pk
			name
			status
		}
		classificationsV2 {
			name
			pk
			type
		}
		classificationSuggestions {
			name
			pk
			type
			confidenceLevel
		}
		locations {
			id
			locationId
			locationType
			name
			pk
		}
		comments {
			...CommentFragment
		}
		type
		importConfirmed
		labels {
			...SimpleLabelFragment
		}
	}
	${CommentFragment}
	${SimpleLabelFragment}
`;
